import { createSelector } from 'reselect';
import {
  findKey,
  isEqualWith,
} from 'lodash/fp';
import { sta as stateMap } from 'config/stateLookup';
import { map as mapColors } from 'config/colors';
import svgPaths from 'config/snapshotMap/usSvgPaths';
import { organizeData } from 'services/breakAndOrganizeData';
import { timeframeLatest } from './timeframe';
import {
  dataSelector,
  geographySelector,
  rangeBreaksSelector,
} from './';

const isEqual = isEqualWith(({ value: a }, { value: b }) => a === b);

const snapshotSelectorFunc = (
  data,
  geographies,
  timeframe,
  usGeo,
  rangeBreaks,
) => {
  const geographyWithAbbrs = Object.keys(geographies).reduce((acc, geo) => ({
    ...acc,
    [geo]: {
      abbr: stateMap[geographies[geo].geography],
      name: geographies[geo].geography,
    },
  }), {});

  const filteredData = data.filter(({ timeframe: time, geography }) =>
    isEqual(time, timeframe) && geography !== usGeo);

  return organizeData(rangeBreaks, filteredData)
    .map((item) => {
      const { abbr, name } = geographyWithAbbrs[item.geography];
      return {
        ...item,
        name,
        abbr,
        color: mapColors[item.bucket],
        d: svgPaths[abbr],
      };
    });
};

const usGeoSelector = createSelector(
  geographySelector,
  findKey(({ code }) => 'US' === code)
);

export const usSelector = createSelector(
  dataSelector,
  timeframeLatest,
  usGeoSelector,
  (data, timeframe, usGeo) => data
    .find(({ timeframe: time, geography }) =>
      isEqual(time, timeframe) &&
      geography === usGeo
    )
);

export const snapshotSelector = createSelector(
  dataSelector,
  geographySelector,
  timeframeLatest,
  usGeoSelector,
  rangeBreaksSelector,
  snapshotSelectorFunc
);

export default {
  snapshotSelector,
  usSelector,
};



// WEBPACK FOOTER //
// ./app/selectors/indicator/usSnapshot.js